// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.ExemptionWorkExperience = {
  exempReference: [],
  exemptReferenceFetched: false,
  exemptReferenceFrontloadRequest: false,
  allWorkExperienceReference: [],
};
